import { inject, Pipe, PipeTransform } from '@angular/core';
import { from, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HubspotConfigLookupService } from '../services/hubspot-config-lookup.service';
import { HubspotContactField } from '../models/survey.model';

@Pipe({
  name: 'hubspotOwnerName',
  standalone: true,
})
export class HubspotOwnerNamePipe implements PipeTransform {
  private readonly lookupService = inject(HubspotConfigLookupService);

  transform(value: HubspotContactField | string): Observable<string> {
    if (!value) {
      return of('');
    }

    if (typeof value === 'object') {
      return value.hubspotId ? this.lookupOwnerById(value.hubspotId) : of(value.name);
    }

    return this.lookupOwnerById(value);
  }

  private lookupOwnerById(ownerId: string): Observable<string> {
    return from(this.lookupService.getOwners()).pipe(
      map((owners) => {
        const owner = owners.find((o) => o.id === ownerId);
        return owner ? `${owner.firstName} ${owner.lastName}` : ownerId;
      }),
    );
  }
}
